/* Form Page to create a Location */
import React, { useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Asset from "../../components/Asset";

import Upload from "../../assets/upload.png";
import styles from "../../styles/PostCreateEditForm.module.css"
import appStyles from "../../App.module.css"
import btnStyles from "../../styles/Button.module.css"
import Image from "react-bootstrap/Image"
import Alert from "react-bootstrap/Alert"

import { useHistory } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import TopBox from "../../components/TopBox"
import { useRedirect } from "../../hooks/Redirect"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast";
import Important from "./Important";

const LocationsCreate = () => {
  useRedirect()
  const host = useHostName()
  const [errors, setErrors] = useState({})
  const [showImp, setShowImp] = useState(false); 
  const [postData, setPostData] = useState({
    name: "",
  })

  const {
    name,
  } = postData

  const history = useHistory()

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    // Validate name
    if (!name) {
      toast.error("A Location Name Must be Added", {
        duration: 2500,
        position: "top-right",
      });
      return;
    }

    const formData = new FormData()

    formData.append("name", name)

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.post("/locations/", formData)
        history.push(`/${localStorage.getItem("projectSlug")}/locations/`)
        toast.success(`Location "${name}" Created`);
      } else {
        await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/locations/`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        history.push(`/${localStorage.getItem("projectSlug")}/locations/`)
        toast.success(`Location "${name}" Created Successfully!`);
      }
    } catch (err) {
      console.log(err)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data)
      }
    }
  }

  const buttons = (
    <div className="text-center">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`} type="submit">
        Create
      </Button>
    </div>
  )

  return (
    <div>
      <TopBox title="Create Location" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} text-left my-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <Button
        className={`float-right my-2 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowImp(showImp => !showImp)} >INFO
       </Button>
       {!showImp ? (
            ""
                ) : (
                  <Important  /> 
        ) } 
      <Container className= {`px-0 ${appStyles.Content} ${styles.Container} mb-0 pb-0`} >
          <Form className="mt-0 mb-0 pb-0" onSubmit={handleSubmit}>
          <h5 className={`text-center mt-0 mb-4 py-0 ${styles.SubTitle }`}>
          CREATE LOCATION</h5>
          <Row>
          <Col md={3} ></Col>
              <Col md={6} className="d-flex justify-content-center">
              <Form.Group controlId="name" className={`${styles.Width} text-center`} >
                      <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
                      <Form.Control 
                      type="text"
                      className={styles.Input}
                      name="name"
                      value={name}
                      onChange={handleChange}
                          />
                  </Form.Group>
                  {errors?.name?.map((message, idx) => (
                    <Alert variant="warning" key={idx}>
                      {message}
                    </Alert>
                  ))}
              </Col>
          </Row>
          <Row className="py-3">
            <Col>
            {buttons}
            </Col>
          </Row>
          </Form>
        </Container>
    </div>
  )
}

export default LocationsCreate
